import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PicksRoutes } from './picks.routing';
import { PickSheetModule } from './pick-sheet/pick-sheet.module';

@NgModule({
  imports: [CommonModule, RouterModule.forChild(PicksRoutes), PickSheetModule],
})
export class PicksModule {}
